import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const helpCenterSettingsBrandingRoute: InvariantJiraRoute = {
	exact: true,
	name: 'helpcenter-settings-branding',
	path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/branding',
};
